import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getJumpUrlHost } from '@src/utils/index';

const Nav = ({ marketVarieties, setClickNavName, clickNavName }) => {
    const clickNavHandle = navName => {
        if (clickNavName) {
            setClickNavName(navName);
        } else {
            window.open(`${getJumpUrlHost('pc')}/marketCenter?navName=${encodeURIComponent(navName)}`);
        }
    };

    return (
        <div className={styles.navBox}>
            <div className={styles.nav}>
                <div className={`${styles.navItem}`}>
                    <div
                        className={styles.navItemName}
                        onClick={() => {
                            clickNavHandle('首页');
                        }}>
                        首页
                        {clickNavName === '首页' && <span className={styles.active} />}
                    </div>
                </div>
                {Object.keys(marketVarieties).map((item, index) => (
                    <div className={`${styles.navItem}`} key={item}>
                        <div
                            className={styles.navItemName}
                            onClick={() => {
                                clickNavHandle(item);
                            }}>
                            {item}
                            {clickNavName === item && <span className={styles.active} />}
                        </div>
                        {/* {navActiveName === item &&
                            isShowSubNav && (
                                <div className={`${styles.subNavBox} ${styles.show}`}>
                                    <div className={styles.subNav}>
                                        {marketVarieties?.[item].map((sItem, sIndex) => (
                                            <div
                                                className={`${styles.subNavItem}`}
                                                onClick={() => {
                                                    clickSubNavHandle(sItem.name);
                                                }}
                                                key={sIndex}>
                                                {sItem?.name || ''}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )} */}
                    </div>
                ))}
            </div>
        </div>
    );
};

Nav.propTypes = {
    marketVarieties: PropTypes.object,
    setClickNavName: PropTypes.func,
    clickNavName: PropTypes.string,
};

export default errorBoundary(Nav);
